import { writable } from 'svelte/store';
import { VideoService } from '@/services';
const initialState = {
    files: [],
    queued: [],
    error: ''
};
let __videos = [];
const videoService = new VideoService();
// Init state
const { subscribe, update } = writable(initialState);
const actions = {
    videoLength() {
        return __videos.length;
    },
    videos() {
        return __videos;
    },
    async addVideo(video) {
        __videos.unshift(video);
        update(fs => {
            return {
                ...fs,
                files: __videos
            };
        });
    },
    async replaceVideo(video) {
        const index = __videos.findIndex(v => v.id === video.id);
        __videos[index] = video;
        update(fs => {
            return {
                ...fs,
                files: __videos
            };
        });
    },
    async getVideoList(page, limit) {
        try {
            const queued = await videoService.getQueuedList();
            const videos = await videoService.getVideoList(page, limit);
            if (page == 1) {
                __videos = videos;
            }
            else {
                __videos = __videos.concat(videos);
            }
            update(fs => {
                return {
                    ...fs,
                    queued,
                    files: __videos
                };
            });
            return { reachedMaxPage: videos.length === 0 };
        }
        catch (error) {
            console.error('getVideoList error', error);
        }
        return { reachedMaxPage: false };
    },
    update
};
const videos = {
    ...actions,
    subscribe
};
export default videos;
